import React from 'react';
import { SmallText } from 'ds/components/typography';
import { TableColumn } from 'ds/components/table';
import { HpdViolation } from 'store/state/selectors/insights/summaryTypes';
import { ViolationTableColumn } from '../styled';
import { CurrentUnitLabel } from '../CurrentUnitLabel';
import { ColumnRendererProps } from 'components/widget/prices/prices-table/utils';

export const getWhereColumnConfig = (): Partial<TableColumn<HpdViolation>> => ({
  sortFn: (items: HpdViolation[]) => items.sort((a, b) => b.location.localeCompare(a.location)),
  width: '30%',
  gap: 16,
  renderFn: (item) => <WhereColumn item={item} />,
});

export const WhereColumn: React.FC<ColumnRendererProps<HpdViolation>> = ({ item }) => {
  return (
    <ViolationTableColumn>
      <SmallText style={{ display: 'flex', alignItems: 'center' }}>
        {item.location}
        {item.isCurrentUnit ? (
          <CurrentUnitLabel />
        ) : null}
      </SmallText>
    </ViolationTableColumn>
  );
};
